import { twMerge } from 'tailwind-merge';

import { accent, neutral } from '../../shared/colors';

function BlymText(props: { color?: 'accent' | 'black'; className?: string }) {
  const fill = props.color === 'accent' ? accent[600] : neutral[950];
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 59 24"
      fill="none"
      className={props.className}
    >
      <g clipPath="url(#clip0_5233_9552)">
        <path
          d="M28.7843 16.6184L25.5166 5.604H22.377L26.2086 18.5177H28.1612L26.3619 23.9999H29.5016L35.5394 5.604H32.3998L28.7843 16.6184Z"
          fill={fill}
        />
        <path
          d="M8.12815 5.36041C6.11151 5.36041 4.33639 6.54091 3.29788 8.33056V0H0.158203V18.3959H3.29788V15.6694C4.33639 17.4591 6.11151 18.6396 8.12815 18.6396C11.3294 18.6396 13.9245 15.667 13.9245 12C13.9245 8.333 11.3294 5.36041 8.12815 5.36041ZM7.04134 15.7157C5.0404 15.7157 3.41863 14.0516 3.41863 12C3.41863 9.94843 5.0404 8.28426 7.04134 8.28426C9.04227 8.28426 10.664 9.94843 10.664 12C10.664 14.0516 9.04227 15.7157 7.04134 15.7157Z"
          fill={fill}
        />
        <path d="M19.3584 0H16.2188V15.2284V18.3959H21.532V15.2284H19.3584V0Z" fill={fill} />
        <path
          d="M53.8349 5.48242C51.8182 5.48242 49.7967 6.81278 49.0891 8.64993C48.5022 6.81278 46.7947 5.48242 44.7781 5.48242C42.788 5.48242 41.0986 6.77867 40.4912 8.57927V5.72608H37.3516V18.518H40.612V11.3301C40.612 9.71592 41.9101 8.40628 43.5102 8.40628C45.1102 8.40628 46.4083 9.71592 46.4083 11.3301V18.518H49.6687V11.3301C49.6687 9.71592 50.9669 8.40628 52.5669 8.40628C54.1669 8.40628 55.4651 9.71592 55.4651 11.3301V18.518H58.3632V10.051C58.3632 7.5279 56.3357 5.48242 53.8349 5.48242Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_5233_9552">
          <rect width="58.2047" height="24" fill="none" transform="translate(0.158203)" />
        </clipPath>
      </defs>
    </svg>
  );
}

function BlymLogo(props: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 21 19"
      fill="none"
      className={props.className}
    >
      <g clipPath="url(#clip0_5233_9557)">
        <path
          d="M20.1432 11.0238L16.7063 16.937C16.0921 17.9921 14.9606 18.6384 13.7383 18.6384H6.86452C5.64224 18.6384 4.51073 17.9921 3.89656 16.937L3.86328 16.8798C4.0206 16.5942 4.20213 16.3117 4.40484 16.0321C4.71646 15.5992 5.08253 15.1693 5.5061 14.7485C5.87822 14.3787 6.26246 14.06 6.65274 13.7955C9.63885 11.7363 12.9033 12.6321 14.5794 13.573C13.6355 11.9046 12.7339 8.66395 14.8033 5.69685C15.0725 5.30605 15.3902 4.92727 15.7654 4.55451C16.1859 4.13665 16.6155 3.7729 17.0542 3.46326C17.2176 3.34903 17.3779 3.2378 17.5413 3.1416L20.1432 7.6178C20.7543 8.67297 20.7543 9.96863 20.1432 11.0238Z"
          fill="#535CDC"
        />
        <path
          d="M16.7402 1.76162C16.5829 2.04721 16.4014 2.33279 16.1987 2.61237C15.887 3.04526 15.521 3.47214 15.0974 3.893C14.7253 4.26276 14.341 4.58142 13.9507 4.84596C10.9616 6.90519 7.70321 6.01236 6.02409 5.06842C6.97106 6.73685 7.86961 9.97751 5.80021 12.9446C5.53095 13.3354 5.21327 13.7142 4.83812 14.087C4.41758 14.5048 3.98495 14.8716 3.54928 15.1812C3.38893 15.2954 3.22556 15.4037 3.06521 15.5029L0.460307 11.0237C-0.150832 9.96849 -0.150832 8.67282 0.460307 7.61766L3.89721 1.7045C4.51137 0.649334 5.64289 0 6.86214 0H13.7359C14.9582 0 16.0897 0.649334 16.7039 1.7045L16.7372 1.76162H16.7402Z"
          fill="#535CDC"
        />
      </g>
      <defs>
        <clipPath id="clip0_5233_9557">
          <rect width="20.6002" height="18.6383" fill="none" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function Blym(props: {
  className?: string;
  variant?: 'two-tone' | 'solid';
  width?: number | string;
}) {
  const textColor = props.variant === 'solid' ? 'accent' : 'black';
  const containerStyle = props.width !== undefined ? { width: props.width } : {};
  const hasCustomWidth = props.width !== undefined;

  // When width is provided: Logo (26.25%) + Text (73.75%) proportional
  // When width is not provided: Logo (21px) + Text (59px) original sizes

  return (
    <div
      className={twMerge('flex items-start justify-start gap-[5.56px]', props.className ?? '')}
      style={containerStyle}
    >
      <BlymLogo
        className={hasCustomWidth ? 'h-auto w-[26.25%] flex-none' : 'h-auto w-[21px] flex-none'}
      />
      <BlymText
        color={textColor}
        className={hasCustomWidth ? 'h-auto w-[73.75%] flex-none' : 'h-auto w-[59px] flex-none'}
      />
    </div>
  );
}

export function BlymFirstTime() {
  return (
    <svg
      width="179"
      height="52"
      viewBox="0 0 179 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_5788_15205)">
        <path
          d="M115.968 36.2073L109.02 12.7859H102.343L110.491 40.246H114.643L110.817 51.9036H117.493L130.332 12.7859H123.656L115.968 36.2073Z"
          fill="#1E2048"
        />
        <path
          d="M72.0427 12.2675C67.7545 12.2675 63.9798 14.7778 61.7715 18.5834V0.869019H55.0952V39.9867H61.7715V34.189C63.9798 37.9945 67.7545 40.5048 72.0427 40.5048C78.85 40.5048 84.3682 34.1838 84.3682 26.3862C84.3682 18.5886 78.85 12.2675 72.0427 12.2675ZM69.7317 34.2874C65.4769 34.2874 62.0283 30.7487 62.0283 26.3862C62.0283 22.0237 65.4769 18.4849 69.7317 18.4849C73.9866 18.4849 77.4351 22.0237 77.4351 26.3862C77.4351 30.7487 73.9866 34.2874 69.7317 34.2874Z"
          fill="#1E2048"
        />
        <path
          d="M95.9236 0.869019H89.2473V33.2512V39.9867H100.546V33.2512H95.9236V0.869019Z"
          fill="#1E2048"
        />
        <path
          d="M169.234 12.5266C164.946 12.5266 160.648 15.3555 159.143 19.2621C157.895 15.3555 154.264 12.5266 149.976 12.5266C145.744 12.5266 142.152 15.283 140.86 19.1119V13.0447H134.184V40.2458H141.117V24.9614C141.117 21.5289 143.877 18.744 147.28 18.744C150.682 18.744 153.442 21.5289 153.442 24.9614V40.2458H160.375V24.9614C160.375 21.5289 163.136 18.744 166.538 18.744C169.941 18.744 172.701 21.5289 172.701 24.9614V40.2458H178.864V22.2413C178.864 16.8762 174.552 12.5266 169.234 12.5266Z"
          fill="#1E2048"
        />
      </g>
      <g clipPath="url(#clip1_5788_15205)">
        <path
          d="M42.018 24.0632L34.8489 36.5047C33.5678 38.7248 31.2075 40.0847 28.6579 40.0847H14.3197C11.7701 40.0847 9.40985 38.7248 8.12875 36.5047L8.05933 36.3845C8.38749 35.7836 8.76614 35.1891 9.18897 34.6008C9.83899 33.69 10.6026 32.7855 11.4861 31.9C12.2624 31.122 13.0638 30.4515 13.8779 29.8949C20.1067 25.5622 26.9161 27.4471 30.4123 29.4269C28.4434 25.9164 26.5627 19.0979 30.8794 12.855C31.441 12.0327 32.1037 11.2358 32.8862 10.4515C33.7634 9.57226 34.6595 8.80692 35.5746 8.15543C35.9154 7.91507 36.2499 7.68104 36.5907 7.47864L42.018 16.8968C43.2928 19.1169 43.2928 21.843 42.018 24.0632Z"
          fill="#535CDC"
        />
        <path
          d="M34.9177 4.57555C34.5895 5.17644 34.2109 5.77733 33.7881 6.36556C33.138 7.27638 32.3744 8.17455 31.4909 9.06007C30.7147 9.83807 29.9132 10.5085 29.0991 11.0651C22.864 15.3979 16.0672 13.5193 12.5647 11.5332C14.54 15.0437 16.4143 21.8622 12.0977 28.1051C11.536 28.9273 10.8734 29.7243 10.0908 30.5086C9.21361 31.3878 8.31116 32.1595 7.4024 32.811C7.06792 33.0513 6.72714 33.279 6.39266 33.4878L0.959023 24.0633C-0.315768 21.8432 -0.315768 19.117 0.959023 16.8969L8.12815 4.45537C9.40925 2.23525 11.7695 0.869019 14.3128 0.869019H28.651C31.2006 0.869019 33.5609 2.23525 34.842 4.45537L34.9114 4.57555H34.9177Z"
          fill="#535CDC"
        />
      </g>
      <defs>
        <clipPath id="clip0_5788_15205">
          <rect
            width="123.768"
            height="51.0343"
            fill="white"
            transform="translate(55.0952 0.869019)"
          />
        </clipPath>
        <clipPath id="clip1_5788_15205">
          <rect width="42.9706" height="39.2159" fill="white" transform="translate(0 0.869019)" />
        </clipPath>
      </defs>
    </svg>
  );
}
